<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout :title="meunTitle"></headerLayout>
        </el-header>
        <el-main class="main" v-loading="tableLoading">
          <div class="mainbody">
            <div class="top">
              <h3 class="title">问卷管理</h3>
              <div class="btn-group-custom">
                <el-button type="text" v-if="cancel" @click="$select()">取消全选</el-button>
                <!-- <el-button type="text" v-else @click="$select()"
                  >全选</el-button
                >-->
                <el-button type="text" @click="$del()">删除</el-button>
                <el-button type="text" @click="importSheet()">导入问卷</el-button>
              </div>
            </div>
            <div class="aLine"></div>

            <div class="tableInfo">
              <el-table
                ref="survey_list"
                :data="survey_list"
                @selection-change="handleSelectionChange"
                v-loading="loading"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="title" label="名称"></el-table-column>
                <el-table-column prop="survey_id" label="问卷ID"></el-table-column>
                <el-table-column prop="count" label="提交数"></el-table-column>
                <el-table-column label="状态">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      v-if="scope.row.state === 'Y'"
                      @click="changeState(scope.row)"
                    >
                      <el-link type="danger" :underline="false">禁用</el-link>
                    </el-button>
                    <el-button type="text" v-else @click="changeState(scope.row)">
                      <el-link type="primary" :underline="false">启用</el-link>
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      class="operateText"
                      size="mini"
                      type="text"
                      @click="surveyInfo(scope.row)"
                    >详情</el-button>
                    <!-- <el-button class="operateText" size="mini" type="text"
                      >编辑</el-button
                    >-->
                    <!-- <el-button
                      class="operateText"
                      size="mini"
                      type="text"
                      @click="adminDelete(scope.row)"
                      >删除</el-button
                    >-->
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                :key="elementui_page_key"
                class="elPagination"
                background
                layout="prev, pager, next"
                :page-size="pageMaxSize"
                :page-count="pageCount"
                :current-page="currentPage"
                @current-change="currentChange"
              ></el-pagination>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as StrUtils from "@/utils/strUtils.js";
import * as Constant from "@/utils/constant.js";
import * as CApi from "@/api/constant_api.js";
import * as Api from "@/api/api.js";
import { URL_PATH, LIST_PAGE_MAX_SIZE } from "@/config/config";
import leftMeun from "@/components/layout/leftMeun";
import headRight from "@/components/layout/headRight";
import headerLayout from "@/components/layout/headerLayoutWxapp";

export default {
  components: {
    leftMeun,
    headRight,
    headerLayout
  },
  data() {
    return {
      meunItem: null,
      tableLoading: false,
      meunTitle: "问卷管理",
      survey_list: [], //问卷列表
      elementui_page_key: 0,
      pageCount: 0, // 所有页数
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      currentPage: 1,
      loading: true,
      selection: [], //勾选状态,
      cancel: false
    };
  },
  methods: {
    initData() {
      this.getSurveyList();
    },
    // 获取问卷列表
    getSurveyList: function(isImport) {
      this.$api
        .getSurveyList({
          token: localStorage.getItem("token"),
          page: this.currentPage,
          limit: this.pageMaxSize
        })
        .then(({ data }) => {
          let pageCount = data.Data.pageCount;
          if (pageCount < this.current_page && data.Data.model.length == 0) {
            this.currentPage = pageCount;
            this.getSurveyList();
          }
          this.pageCount = data.Data.pageCount;
          this.survey_list = data.Data.model;
          this.loading = false;
          if (isImport === true) {
            this.$message({
              message: "导入成功",
              type: "success"
            });
          }
        })
        .catch(({ error }) => {});
    },
    // 导入问卷
    importSheet: function() {
      this.$api
        .importSheet({
          token: localStorage.getItem("token")
        })
        .then(({ data }) => {
          this.getSurveyList(true);
        })
        .catch(({ error }) => {});
    },
    // 问卷详情
    surveyInfo: function(row) {
      if (row.survey_id) {
        localStorage.setItem("survey_id", row.survey_id);
        this.$router.push({
          path: "/wxapp/survey"
        });
      } else {
        this.$message({
          message: "问卷不存在"
        });
      }
    },
    // 勾选状态
    handleSelectionChange(val) {
      this.selection = [];
      if (val && val.length > 0) {
        val.forEach(item => {
          this.selection.push(item.survey_id);
        });
      }
      if (val && val.length == this.survey_list.length) {
        this.cancel = true;
      } else {
        this.cancel = false;
      }
    },
    // 删除问卷
    $del() {
      if (this.selection.length > 0) {
        this.$confirm("是否删除该问卷", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.$api
              .delSurvey({
                token: localStorage.getItem("token"),
                survey_ids: JSON.stringify(this.selection)
              })
              .then(({ data }) => {
                this.getSurveyList();
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              })
              .catch(({ error }) => {});
          })
          .catch(() => {});
      } else {
        this.$message.error("至少选择一条数据");
      }
    },
    $select() {
      this.$refs.survey_list.toggleAllSelection();
    },
    changeState(val) {
      this.$api
        .editSurvey({
          token: localStorage.getItem("token"),
          survey_id: val.survey_id,
          state: val.state === 'Y' ? 'N' : 'Y'
        })
        .then(({ data }) => {
          this.getSurveyList();
        })
    },
    // 分页控制
    currentChange(val) {
      this.elementui_page_key++;
      this.currentPage = val;
      this.getSurveyList();
    }
  }
};
</script>

<style  scoped>
.top {
  position: relative;
}
.top .btn-group-custom {
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  right: 32px;
}
.top .btn-group-custom .el-button--text {
  color: #595959;
}
.top .btn-group-custom .el-button--text:hover {
  color: #1890ff;
}
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
}
.el-pagination {
  margin: 20px 0;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-right: 32px;
}
.mainbody .tableInfo_margin {
  margin-top: 62px;
}
.mainbody .tableInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.addData_bor {
  margin-top: 26px;
  border: 1px dashed #b1b1b1;
  border-radius: 4px;
  width: 100%;
  height: 32px;
  text-align: center;
}
.addData_bor .addData_style {
  font-size: 14px;
  color: #848484;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  height: 32px;
}
.operateText {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/wxapp/surveyManager.vue